document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('[data-testimonials-slider]');
  if (slider && typeof Splide !== 'undefined') {
    const columns = parseInt(slider.dataset.columns || 3);
    const autoplay = slider.dataset.autoplay === 'true';
    const wrap = slider.closest('.testimonials__carousel-wrap');

    const splide = new Splide(slider, {
      type: 'loop',
      perPage: columns,
      perMove: 1,
      gap: '1.5rem',
      autoplay: autoplay,
      interval: 5000,
      pauseOnHover: true,
      arrows: false,
      breakpoints: {
        1024: { perPage: 2 },
        640: { perPage: 1 }
      }
    }).mount();

    if (wrap) {
      const prevBtn = wrap.querySelector('.testimonials__arrow--prev');
      const nextBtn = wrap.querySelector('.testimonials__arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
      if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));
    }
  }
});
